export const DEFAULT_LANGUAGE = "en-gb";
export const DEFAULT_LANGUAGE_WITHOUT_REGION = DEFAULT_LANGUAGE.substring(0, 2);
export const DEFAULT_PLATFORM_NAME = "RegReview";

export const MAX_FILE_SIZE_UPLOAD = 1024 * 1024 * 10; // 10MB
export const MAX_GLOBAL_SIZE_UPLOAD = 1024 * 1024 * 100; // 100MB;

export const LIMIT_ITEMS_PREVIEW = 10;
